import type { Ref } from 'vue'
import L from 'leaflet'

export function useUnits(map: Ref<any>, screenBounds: any) {
    function isUnitOutsideBounds(unitLatLng: [number, number], mapBounds: any) {
        const { _northEast, _southWest } = mapBounds
        const [unitLat, unitLng] = unitLatLng

        return (
            unitLat > _northEast.lat ||
            unitLat < _southWest.lat ||
            unitLng > _northEast.lng ||
            unitLng < _southWest.lng
        )
    }

    function getBordeCercano(
        unitLatLng: [number, number],
        mapBounds: { _northEast: { lat: number; lng: number }, _southWest: { lat: number; lng: number } },
        offsetPx = 20
    ): [number, number] {
        const { _northEast, _southWest } = mapBounds
        const [unitLat, unitLng] = unitLatLng
        let newUnitLat = unitLat
        let newUnitLng = unitLng
        let dx = 0
        let dy = 0

        const leafletMap = map.value?.leafletObject
        if (!leafletMap) return [unitLat, unitLng]

        function moveInward(lat: number, lng: number, dx: number, dy: number) {
            if (!leafletMap) return [lat, lng] as [number, number]
            
            // Verificar que el mapa tenga centro y zoom configurados
            const center = leafletMap.getCenter()
            const zoom = leafletMap.getZoom()
            if (!center || zoom === undefined) {
                return [lat, lng] as [number, number]
            }
            
            const point = leafletMap.latLngToContainerPoint([lat, lng])
            const moved = L.point(point.x + dx, point.y + dy)
            const latlng = leafletMap.containerPointToLatLng(moved)
            return [latlng.lat, latlng.lng] as [number, number]
        }

        if (unitLat > _northEast.lat) {
            newUnitLat = _northEast.lat
            dy = offsetPx
        } else if (unitLat < _southWest.lat) {
            newUnitLat = _southWest.lat
            dy = -(offsetPx + 45)
        }
        if (unitLng > _northEast.lng) {
            newUnitLng = _northEast.lng
            dx = -offsetPx
        } else if (unitLng < _southWest.lng) {
            newUnitLng = _southWest.lng
            dx = offsetPx
        }
        return moveInward(newUnitLat, newUnitLng, dx, dy)
    }

    function getMarkerPosition(unit: any): [number, number] {
        const mapBounds = screenBounds.value
        const unitLatLng: [number, number] = [unit.location.coordinates[1], unit.location.coordinates[0]]

        // Verificar que los bounds sean válidos
        if (!mapBounds || 
            !mapBounds._northEast || 
            !mapBounds._southWest ||
            mapBounds._northEast.lat === 0 && mapBounds._northEast.lng === 0 &&
            mapBounds._southWest.lat === 0 && mapBounds._southWest.lng === 0) {
            return unitLatLng
        }

        if (isUnitOutsideBounds(unitLatLng, mapBounds)) {
            return getBordeCercano(unitLatLng, mapBounds)
        }
        return unitLatLng
    }

    function unitColor(unit_id: string) {
        switch (unit_id) {
            case 'LA':
                return 'red'
            case 'GB':
                return 'blue'
            case 'CC':
                return 'green'
            default:
                return 'black'
        }
    }

    return {
        getMarkerPosition,
        isUnitOutsideBounds,
        unitColor,
    }
}